import React from 'react'
import '../styles/Collection2.css'

const image1 = process.env.PUBLIC_URL + '/i1.jpeg'
const image2 = process.env.PUBLIC_URL + '/i2.jpeg'
const image3 = process.env.PUBLIC_URL + '/i3.jpeg'
const image4 = process.env.PUBLIC_URL + '/i4.jpeg'
const image5 = process.env.PUBLIC_URL + '/i5.jpeg'

function Collection2() {
  const currentYear = new Date().getFullYear()
  const currentMonth = new Date().getMonth()
  
  const getSeason = () => {
    if (currentMonth >= 2 && currentMonth <= 4) return 'SPRING'
    if (currentMonth >= 5 && currentMonth <= 7) return 'SUMMER'
    if (currentMonth >= 8 && currentMonth <= 10) return 'AUTUMN'
    return 'WINTER'
  }
  
  return (
    <div className='collection-body'>
      <div className="left-container">
        <div className="images">
          <div className="left-image">
            <img src={image1} alt="" />
          </div>
          <div className="right-image">
            <img src={image2} alt="" />
          </div>
        </div>
      </div>
      <div className="right-container">
        <div className="images2">
          <div className="right-image2">
            <img src={image3} alt="" />
          </div>
          <div className="left-image2">
            <img src={image5} alt="" />
            <span className="left-image2-text">NEW ARRIVALS<br/>{getSeason()} {currentYear}</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Collection2